import authService from '../components/api-authorization/AuthorizeService'
import { GetMemberByFingerprintQuery } from '../models/member/GetMemberByFingerprintQuery/GetMemberByFingerprintQuery';
import { GetMemberByIdQuery } from '../models/member/GetMemberByIdQuery/GetMemberByIdQuery';
import { MemberViewModel } from '../models/member/MemberViewModel';
import { SignInToEventCommand } from '../models/member/SignInToEventCommand/SignInToEventCommand'
import { SignOutOfEventCommand } from '../models/member/SignOutOfEventCommand/SignOutOfEventCommand'
import { AddNoteCommand } from '../models/member/AddNoteCommand/AddNoteCommand'
import { DeleteNoteCommand } from '../models/member/DeleteNoteCommand/DeleteNoteCommand'
import  EditMemberCommand  from '../models/member/EditMemberCommand'
import { UseFormSetError } from 'react-hook-form';
import BulkUploadErrorModel from '../models/membership/BulkUploadErrorModel';
import { MemberEventViewModel } from '../models/member/MemberEventViewModel';
import DeleteMemberCommand from '../models/member/DeleteMemberCommand';

export default class MemberController {
    async GetMemberByFingerprint(model: GetMemberByFingerprintQuery): Promise<MemberViewModel | null> {
        const token = await authService.getAccessToken();
        const response = await fetch('member/GetMemberByFingerprint', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': `application/json` },
            method: 'POST',
            body: JSON.stringify(model)
        });
        if (response.status == 200) {
            const data = await response.json();
            return data;
        }
        return null;
    }

    async GetMemberById(model: GetMemberByIdQuery): Promise<MemberViewModel | null> {
        const token = await authService.getAccessToken();
        const response = await fetch('member/GetMemberById', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': `application/json` },
            method: 'POST',
            body: JSON.stringify(model)
        });
        if (response.status == 200) {
            const data = await response.json();
            return data;
        }
        return null;
    }


    async SearchMembers(dateOfBirth: string, surname: string): Promise<MemberViewModel[] | null> {
        const token = await authService.getAccessToken();
        const response = await fetch('member/SearchMembers?dateOfBirth=' + dateOfBirth + "&surname=" + surname, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': `application/json` },
            method: 'GET',
        });
        if (response.status == 200) {
            const data = await response.json();
            return data;
        }
        return null;
    }

    async GetEventsForMember(id: string): Promise<MemberEventViewModel[] | null> {
        const token = await authService.getAccessToken();
        const response = await fetch('member/GetEventsForMember?id=' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': `application/json` },
            method: 'GET',
        });
        if (response.status == 200) {
            const data = await response.json();
            return data;
        }
        return null;
    }

    async SignIn(model: SignInToEventCommand): Promise<boolean> {
        const token = await authService.getAccessToken();
        const response = await fetch('member/SignIn', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': `application/json` },
            method: 'POST',
            body: JSON.stringify(model)
        });
        if (response.status == 200) {
            return true;
        }
        return false;
    }

    async SignOut(model: SignOutOfEventCommand): Promise<boolean> {
        const token = await authService.getAccessToken();
        const response = await fetch('member/SignOut', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': `application/json` },
            method: 'POST',
            body: JSON.stringify(model)
        });
        if (response.status == 200) {
            return true;
        }
        return false;
    }

    async AddNoteToMember(model: AddNoteCommand): Promise<boolean> {
        const token = await authService.getAccessToken();
        const response = await fetch('member/AddNoteToMember', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': `application/json` },
            method: 'POST',
            body: JSON.stringify(model)
        });
        if (response.status == 200) {
            return true;
        }
        return false;
    }

    async DeleteNoteFromMember(model: DeleteNoteCommand): Promise<boolean> {
        const token = await authService.getAccessToken();
        const response = await fetch('member/DeleteNoteFromMember', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': `application/json` },
            method: 'POST',
            body: JSON.stringify(model)
        });
        if (response.status == 200) {
            return true;
        }
        return false;
    }

    async BulkUpload(file: File): Promise<BulkUploadErrorModel[] | null> {         
        var data = new FormData();
        data.append("file", file);
        const token = await authService.getAccessToken();
        const response = await fetch('member/BulkUpload', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Accept': 'application/json' },
            method: 'POST',
            body: data
        });
        var body = await response.json();
        if (response.status == 200) {
            return body;
        }
        if(response.status == 400 && body)
        {
             Object.keys(body).forEach((key) => {
                console.log(body[key][0]);
                throw new Error(`${body[key][0]}`)
            })
        }
        return null;
    }

    async EditMember(model: EditMemberCommand, setError: UseFormSetError<any>): Promise<boolean> {
        const token = await authService.getAccessToken();
        const response = await fetch('member/EditMember', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': `application/json` },
            method: 'POST',
            body: JSON.stringify(model)
        });
        if (response.status == 200) {
            return true;
        }
        var body = await response.json();
        if(response.status == 400 && body.errors)
        {
            var errors = body.errors
            Object.keys(errors).forEach((key) => {
                console.log(key);
                setError(key, { type: "server", message: errors[key] })
            })
            return false
        }
        return false;
    }

    async DeleteMember(model: DeleteMemberCommand): Promise<boolean> {
        const token = await authService.getAccessToken();
        const response = await fetch('member/DeleteMember', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': `application/json` },
            method: 'POST',
            body: JSON.stringify(model)
        });
        if (response.status == 200) {
            return true;
        }
        var body = await response.json();
        if(response.status == 400 && body.errors)
        {
            var errors = body.errors
            Object.keys(errors).forEach((key) => {
                console.log(key);
            })
            return false
        }
        return false;
    }
}